import React, { useState } from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { ReactComponent as PollTickIcon } from '../../img/poll-tick.svg';
import imgParams from '../../utils/imageUtil';

const ImagePoll = ({
  handleSubmitPoll,
  pollId,
  options,
  showResult,
  disablePollOption,
}) => {
  const classes = useStyles();
  const [hoverIndex, setHoverIndex] = useState(-1);
  const boxHeight =
    options &&
    options.length > 0 &&
    (options[0].description.length > 15 || options[1].description.length > 15)
      ? '62px'
      : '40px';

  return (
    <React.Fragment>
      <Box className={classes.parentBox}>
        {options &&
          options.map((option, index) => {
            return (
              <Box
                key={index}
                width="100%"
                onClick={(e) => handleSubmitPoll(e, pollId, option.id, index)}
                style={{ cursor: showResult ? 'default' : 'pointer' }}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(-1)}
              >
                <img
                  src={imgParams(option.imageUrl, 720)}
                  alt="ImagePoll"
                  className={classes.pollImgSet}
                />
                {disablePollOption.index === index &&
                  disablePollOption.value && (
                    <Box className={classes.disableListItem}></Box>
                  )}
                {showResult ? (
                  <Box className={classes.resultBox}>
                    <Box
                      className={classes.greyLayer}
                      height={boxHeight}
                      style={{
                        borderBottomRightRadius:
                          option.voteResults === '100%' ? '8px' : '0px',
                        backgroundColor: option.isVoted ? '#ffecee' : '#ececec',
                      }}
                      width={option.voteResults}
                    />
                    <Box className={classes.descriptionBox} height={boxHeight}>
                      <Typography style={{ width: '60%' }}>
                        {option.description}
                      </Typography>
                      <Box style={{ display: 'flex', gap: '3px' }}>
                        {option.isVoted && <PollTickIcon alt="TickIcon" />}
                        <Typography
                          style={{
                            color: option.isVoted ? '#DC4541' : '#3c3c3c',
                          }}
                        >
                          {option.voteResults}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ) : (
                  <Box
                    className={classes.descriptionBox}
                    height={boxHeight}
                    style={{
                      position: 'relative',
                      backgroundColor:
                        hoverIndex === index
                          ? showResult
                            ? '#fff'
                            : '#ffecee'
                          : '#fff',
                    }}
                  >
                    <Typography style={{ width: '60%' }}>
                      {option.description}
                    </Typography>
                  </Box>
                )}
              </Box>
            );
          })}
      </Box>
    </React.Fragment>
  );
};
const useStyles = makeStyles((theme) => ({
  parentBox: {
    width: '100%',
    display: 'flex',
    gap: '10px',
  },
  resultBox: {
    borderBottomRightRadius: '8px',
    borderBottomLeftRadius: '8px',
    border: '1px solid #ececec',
    marginTop: '-3.3px',
    width: '100%',
    position: 'relative',
  },
  pollImgSet: {
    height: '160px',
    width: '100%',
    position: 'relative',
    zIndex: 2,
    borderTopLeftRadius: theme.spacing(2),
    borderTopRightRadius: theme.spacing(2),
  },
  disableListItem: {
    background: '#fff',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: '1',
    top: theme.spacing(0),
  },
  greyLayer: {
    marginTop: '-3.3px',

    borderBottomLeftRadius: theme.spacing(2),
  },
  descriptionBox: {
    top: '0px',
    width: '100%',
    zIndex: 1,
    display: 'flex',
    position: 'absolute',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 5px',
    marginTop: '-3.3px',
    borderBottomRightRadius: '8px',
    borderBottomLeftRadius: '8px',
    border: '1px solid #ececec',
    color: '#3c3c3c',
  },
}));
export default ImagePoll;
